import type { FunctionComponent } from 'react';
import { InvalidPermissionError } from './Errors';

type Props = {
  checkPermission: () => boolean;
};

/**
 * OrganizationSettingsPermissionGate is a wrapper component that checks if the user has permission to view the
 * organization settings page. If the user does not have permission, it renders an error page.
 * Else, it renders the children.
 */
const OrganizationSettingsPermissionGate: FunctionComponent<Props> = ({ children, checkPermission }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return checkPermission() ? <>{children}</> : <InvalidPermissionError />;
};

export default OrganizationSettingsPermissionGate;
